import { render, staticRenderFns } from "./BaseDescription.vue?vue&type=template&id=119fbfbe&"
import script from "./BaseDescription.vue?vue&type=script&lang=js&"
export * from "./BaseDescription.vue?vue&type=script&lang=js&"
import style0 from "./BaseDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports